import {z} from 'zod'

const workerTypeRawSchema = z.object({
    id: z.string(),
    name: z.string(),
    is_driver: z.boolean().default(false),
    is_technician: z.boolean().default(false),
})

export const workerTypeSchema = workerTypeRawSchema.transform((raw) => ({
    id: raw.id,
    name: raw.name,
    isDriver: raw.is_driver,
    isTechnician: raw.is_technician,
}))

export type WorkerTypeRaw = z.input<typeof workerTypeRawSchema>
export type WorkerType = z.infer<typeof workerTypeSchema>

export const createWorkerTypeInputSchema = z.object({
    name: z.string().transform((value) => value.trim()),
    isDriver: z.boolean().optional(),
    isTechnician: z.boolean().optional(),
})

export type CreateWorkerTypeInput = z.input<typeof createWorkerTypeInputSchema>

export const createWorkerTypeRequestSchema = createWorkerTypeInputSchema.transform(
    ({name, isDriver, isTechnician}) => ({
        name,
        ...(isDriver === undefined ? {} : {is_driver: isDriver}),
        ...(isTechnician === undefined ? {} : {is_technician: isTechnician}),
    }),
)

export type CreateWorkerTypeRequestRaw = z.infer<typeof createWorkerTypeRequestSchema>

export const updateWorkerTypeInputSchema = createWorkerTypeInputSchema

export type UpdateWorkerTypeInput = z.input<typeof updateWorkerTypeInputSchema>

export const updateWorkerTypeRequestSchema = createWorkerTypeRequestSchema

export type UpdateWorkerTypeRequestRaw = z.infer<typeof updateWorkerTypeRequestSchema>
